import { createFileRoute, notFound } from "@tanstack/react-router";
import ReferenceDetailPage from "@/pages/ReferenceDetailPage";
import NotFound from "@/pages/NotFound";
import { buildRouteHead } from "@/lib/route-head";
import { references } from "@/data/references";
import { breadcrumbSchema, creativeWorkSchema } from "@/lib/schema";

export const Route = createFileRoute("/referenzen/$id")({
  // Ohne echten 404-Status werten Google & Co. unbekannte IDs als Soft-404.
  loader: ({ params }) => {
    if (!references.some((r) => r.id === params.id)) {
      throw notFound();
    }
  },
  notFoundComponent: NotFound,
  head: ({ params }) => {
    const ref = references.find((r) => r.id === params.id);
    if (!ref) {
      return buildRouteHead({
        title: "Referenz nicht gefunden | Enno & Jens",
        description: "Diese Referenz existiert nicht. Zur Übersicht aller Referenzen.",
        path: `/referenzen/${params.id}`,
        noIndex: true,
      });
    }
    const rawImage = ref.screenshotDesktop ?? ref.image;
    const image =
      rawImage.endsWith(".webp") ||
      rawImage.endsWith(".jpg") ||
      rawImage.endsWith(".png")
        ? rawImage
        : `${rawImage}-1366.webp`;
    const path = `/referenzen/${ref.id}`;
    const scripts = [
      creativeWorkSchema({
        name: ref.title,
        description: ref.summary,
        path,
        image,
        url: ref.url,
        datePublished: ref.datePublished,
        dateModified: ref.dateModified,
        keywords: [ref.category, ref.industry, ...ref.services],
      }),
      breadcrumbSchema([
        { name: "Startseite", path: "/" },
        { name: "Referenzen", path: "/referenzen" },
        { name: ref.title, path },
      ]),
    ];
    return buildRouteHead({
      title: `${ref.title} | Referenz Enno & Jens`,
      description: `Referenz der Agentur aus Wernigerode: ${ref.summary.slice(0, 140)}`,
      path,
      image,
      imageAlt: `Referenzprojekt ${ref.title}`,
      imageWidth: 1366,
      imageHeight: 1196,
      ogType: "article",
      scripts,
    });
  },
  component: ReferenceDetailPage,
});
